import { Component, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreenLayout, SCREEN_LAYOUT } from '../core/layout/layout.provider';
import { CustomerService } from '../customer/customer.service';
import { DataService } from '../data/data.service';
import { ConfirmDeleteComponent } from '../core/components/confirm-delete.component';
import { PosSoundService } from '../core/pos-sound.service';

@Component({
    selector: 'app-cart-page',
    template: `
    <div
      class="d-flex h-100 w-100 flex-column"
      [ngClass]="screenLayout === 'desktop' ? 'justify-content-center' : 'justify-content-between top bottom'"
      >
      <div *ngIf="!dataService.hasEntryInCart && screenLayout === 'desktop'" i18n class="text-center fs-5 px-4 py-2 my-1">
        Durch Antippen der Produkte diese zum Warenkorb hinzufügen.
      </div>

      <div class="d-flex flex-column flex-shrink-1 overflow-hidden h-100" *ngIf="dataService.hasEntryInCart">
        <div class="d-flex flex-row justify-content-between align-items-center w-100 p-3 pe-2 p-xl-3">
          <span class="fs-4 fw-bold" i18n>Warenkorb</span>
          <button type="button"
                  class="btn btn-sm btn-rounded-icon btn-light-danger me-1"
                  (click)="clearCart()">
            <span class="material-icons md-24">delete_forever</span>
          </button>
        </div>
        <div class="overflow-y-auto">
          <app-cart-content [showItemCounters]="screenLayout === 'mobile'"></app-cart-content>
        </div>
      </div>

      <div *ngIf="!dataService.hasEntryInCart && screenLayout === 'mobile'"></div>
      <div class="d-flex flex-column flex-shrink-1 justify-content-between align-items-center text-center" *ngIf="!dataService.hasEntryInCart && screenLayout === 'mobile'">
        <span class="material-icons text-muted md-64">storefront</span>
        <div i18n class="text-center fs-5 px-4">
          Produkte antippen und zum Warenkorb hinzufügen.
        </div>
        <button type="button" class="btn btn-producten mt-3 px-4" routerLink="/">
          Zu den Produkten
        </button>
      </div>

      <div [class.bg-white]="screenLayout === 'mobile'" class="flex-grow-0 flex-shrink-1">
        <app-cart-footer></app-cart-footer>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    .btn-producten {
      background-color: #00477a;
      color: white;
      font-size: 20px;
    }
  `],
    standalone: false
})
export class CartPage {
  constructor(
    @Inject(SCREEN_LAYOUT) public screenLayout: ScreenLayout,
    public dataService: DataService,
    private readonly customerService: CustomerService,
    private readonly modalService: NgbModal,
    private readonly sound: PosSoundService) {
  }

  async clearCart() {
    const modalRef = this.modalService.open(ConfirmDeleteComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.title = 'Warenkorb leeren';
    modalRef.componentInstance.message = 'Sind Sie sicher, dass Sie alle Produkte aus dem Warenkorb entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.';
    modalRef.componentInstance.confirmButtonText = 'Warenkorb leeren';
    modalRef.componentInstance.cancelButtonText = 'Abbrechen';

    const confirmed = await modalRef.result.then(result => result, () => false);

    if (!confirmed) {
      return;
    }

    this.dataService.clearCart();
    this.sound.remove();
  }
}
